import useQuery from 'hooks/useQuery';

const useUploadDocuments = () => {
  const query = useQuery();
  const isUploadDocumentsTrigger =
    query.get('isUploadDocumentsTrigger') === 'true';

  return { isUploadDocumentsTrigger };
};

export default useUploadDocuments;
